<template>

    <!-- Common Banner Area -->
    <!-- <TermsBanner /> -->

    <!-- Privacy Policy Areas -->
    <TermsContent tipo="TICKET-SHOP"/>

    <!-- Cta Area -->
    <!-- <Cta /> -->

</template>
<script>
// import TermsBanner from '@/components/pages/TermsBanner.vue'
import TermsContent from '@/components/pages/TermsContent.vue'
import Cta from '@/components/home/Cta.vue'

export default {
    name: "PrivacyPolicyView",
    components: {
        TermsContent, Cta
    }
};
</script>
